module.exports = __webpack_public_path__ + "img/Order-total-bg.11911e9b.11911e9b.jpg";